const ALLOWED_ICON_UPLOAD_TYPES = [ 'image/png', 'image/svg+xml', ];

/**
 * Validates a filename for the navigation button "Upload Image" icon family.
 * Only PNG and SVG are accepted.
 *
 * @param {string} [filename] - may be undefined/empty (treated as not allowed)
 * @returns {boolean}
 */
export const isAllowedIconUploadFilename = (filename) => {
	const name = (filename || '').toLowerCase();
	return name.endsWith('.png') || name.endsWith('.svg');
};

/**
 * Validates a File chosen for the navigation button "Upload Image" icon family.
 * Requires a PNG/SVG extension AND a matching MIME type so a non-image renamed
 * to .png/.svg can't slip through and render as a broken icon in Condor.
 * file.type is allowed to be empty — some browsers don't populate it (notably
 * for SVG) — so only a populated, non-matching type is rejected.
 *
 * @param {File} [file]
 * @returns {boolean}
 */
export const isAllowedIconUploadFile = (file) => {
	if (!file || !isAllowedIconUploadFilename(file.name)) {
		return false;
	}
	return !file.type || ALLOWED_ICON_UPLOAD_TYPES.includes(file.type);
};
